
import { _1080x1350 } from './_1080x1350';
import { _custom } from './_custom';
import { email } from './email';
import { flyer } from './flyer';
import { flyerDouble } from './flyerDouble';
import { flyerSingle } from './flyerSingle';
import { landscape } from './landscape';
import { listingOverlay } from './listingOverlay';
import { portrait } from './portrait';
import { postcardJumbo } from './postcardJumbo';
import { postcardSmall } from './postcardSmall';
import { postcardStandard } from './postcardStandard';
import { presetDefinitions } from './presetDefinitions';
import { square } from './square';
import { story } from './story';

// We can export presetData directly as it contains all necessary information.
// The previous mapping was overwriting correct preset data with generic layouts.
const presets = presetDefinitions;
const presetData = {
  landscape,
  square,
  portrait,
  _1080x1350,
  postcardStandard,
  postcardJumbo,
  flyer,
  story,
  flyerSingle,
  flyerDouble,
  postcardSmall,
  _custom,
  email,
  listingOverlay,
};

export {
  presets,
  presetData,
};

export default presets;
